
/**
 * 模組代碼 : -
 * 模組說明 : (共用模組) 彈出式訊息視窗
 * @module web/components/MessageModal
 */

// ----- import from npm modules -----
import React, { useState, useEffect } from 'react';

// ----- constants and enums -----
const MessageModalModeEnums = {
    ERROR: 'error',
    WARNING: 'warning',
    INFO: 'info',
};

const MessageModal = React.forwardRef((props, ref) => {
    const { mode, title, message } = props;

    const [style, setStyle] = useState({});
    const modeStyles = {
        error: {
            badgeClass: 'modal__title__badge--alert',
            iconHref: '#ico-error',
        },
        warning: {
            badgeClass: 'modal__title__badge--alert',
            iconHref: '#ico-error',
        },
        info: {
            badgeClass: 'modal__title__badge--success',
            iconHref: '#ico-info',
        },
    };

    // 将换行符转换为 <br /> 标签
    const formattedMessage = message.split('<br />').map((line, index) => (
        <React.Fragment key={index}>
            {line}
            <br />
        </React.Fragment>
    ));

    useEffect(() => {
        setStyle(modeStyles[mode]);
    }, [mode]);

    if (message.includes('401 Unauthorized')) {
       return (<div></div>);
    }

    return (
        <div ref={ref}
            className="modal fade" id="modalMessage" tabIndex="-1" aria-labelledby="modalMessageLabel" aria-hidden="true">
            <div className="modal-dialog modal-sm modal-dialog-centered">
                <form className="modal__form modal-content" id="modalMessageForm">
                    <div className="modal-header border-bottom-0">
                        <h1 className="modal-title fs-5" id="modalMessageLabel">
                            <div className={`modal__title__badge ${style.badgeClass}`} id="modalAlertBadge">
                                {mode === MessageModalModeEnums.ERROR ?
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="red" className="bi bi-exclamation-triangle" viewBox="0 0 16 16">
                                        <path d="M7.938 2.016A.13.13 0 0 1 8.002 2a.13.13 0 0 1 .063.016.15.15 0 0 1 .054.057l6.857 11.667c.036.06.035.124.002.183a.2.2 0 0 1-.054.06.1.1 0 0 1-.066.017H1.146a.1.1 0 0 1-.066-.017.2.2 0 0 1-.054-.06.18.18 0 0 1 .002-.183L7.884 2.073a.15.15 0 0 1 .054-.057m1.044-.45a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767z"/>
                                        <path d="M7.002 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0M7.1 5.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0z"/>
                                    </svg> :
                                ''}
                                {mode === MessageModalModeEnums.WARNING ?
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="red" className="bi bi-exclamation-triangle" viewBox="0 0 16 16">
                                        <path d="M7.938 2.016A.13.13 0 0 1 8.002 2a.13.13 0 0 1 .063.016.15.15 0 0 1 .054.057l6.857 11.667c.036.06.035.124.002.183a.2.2 0 0 1-.054.06.1.1 0 0 1-.066.017H1.146a.1.1 0 0 1-.066-.017.2.2 0 0 1-.054-.06.18.18 0 0 1 .002-.183L7.884 2.073a.15.15 0 0 1 .054-.057m1.044-.45a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767z"/>
                                        <path d="M7.002 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0M7.1 5.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0z"/>
                                    </svg> :
                                ''}
                                {mode === MessageModalModeEnums.INFO ?
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="green" className="bi bi-info-circle" viewBox="0 0 16 16">
                                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
                                        <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>
                                    </svg> :
                                ''}
                            </div>
                            <div id="modalTitle" className="modal__title__text">{title}</div>
                        </h1>
                        <button type="button" className="btn-close btn-cancel" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">{formattedMessage}</div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-cancel" data-bs-dismiss="modal">確定</button>
                    </div>
                </form>
            </div>
        </div>
    );
});

export { MessageModal, MessageModalModeEnums };